import axios from 'axios';
import { AuthHeaders } from '../../core/constants/apiTypes';
import { applicationStore } from '../../store/applicationStore';

let interceptorsId = null;
export const httpClient = axios.create({
  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
  },
});

export const setHttpClientInterceptors = () => {
  if (interceptorsId || interceptorsId === 0) {
    httpClient.interceptors.request.eject(interceptorsId);
  }

  interceptorsId = httpClient.interceptors.request.use(
    (config) => {
      const { accessToken: token, isAuthDataReceived } = applicationStore;
      const accessToken = isAuthDataReceived && token ? `${AuthHeaders.Bearer} ${token}` : '';

      if (accessToken) {
        config.headers[AuthHeaders.Authorization] = accessToken;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};
